import { render } from "./company-list.vue?vue&type=template&id=626bde76"
import script from "./company-list.vue?vue&type=script&lang=js"
export * from "./company-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__